import { createFileRoute } from "@tanstack/react-router"
import { LoadingScreen } from "@/ui/components"

export const Route = createFileRoute("/(user)/admin/")({
  component: RouteComponent,
})

// /admin has no landing page of its own; AdminRoute forwards to the queue
function RouteComponent() {
  return <LoadingScreen />
}
